import React, { useState, useEffect, useRef } from 'react'
import { connectTimeSettingsDesktop } from './TimeSettingsDesktop.connect'
import { formatTime } from '../../../helpers/date.helper'

const monthName = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const TimeSettingsDesktop = ({
  timeZoneName = '',
  serverTime,
  actions, ...props }) => {
  const [timeCounter, setTimeCounter] = useState(0)
  const [timeUTC, setTimeUTC] = useState(false);




  useEffect(() => {
    const timer = setInterval(() => {
      setTimeCounter(timeCounter => timeCounter + 1);
    }, 1000);
    return () => clearInterval(timer)
  }, [timeCounter]);

 
  useEffect(() => {
    // actions.requestServerTime().then((res) => res)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const getDate = () => {
    const now = new Date()
    if (timeZoneName === 'system')
      return `${monthName[now.getUTCMonth()]} ${now.getUTCDate()}th, ${now.getUTCFullYear()}`
      
    else if (timeZoneName === 'device')
      return `${monthName[now.getMonth()]} ${now.getDate()}th, ${now.getFullYear()}`
      
    else {
      now.setMinutes(now.getMinutes() + now.getTimezoneOffset() + 330)
      return `${monthName[now.getMonth()]} ${now.getDate()}th, ${now.getFullYear()}`
    }
  }

  const getTime = () => {
    const now = new Date()
    if (timeZoneName === 'system')
      return `${formatTime(now.getUTCHours())}:${formatTime(now.getUTCMinutes())}:${formatTime(now.getUTCSeconds())}`
    else if (timeZoneName === 'device')
      return `${formatTime(now.getHours())}:${formatTime(now.getMinutes())}:${formatTime(now.getSeconds())}`
    else {
      now.setMinutes(now.getMinutes() + now.getTimezoneOffset() + 330)
      return `${formatTime(now.getHours())}:${formatTime(now.getMinutes())}:${formatTime(now.getSeconds())}`
    }
  }

// close time dropdown after click somewhere
  const contentDateRef = useRef(null)
  const closeTime = (e) => !e.path?.includes(contentDateRef.current) ? setTimeUTC(false) : ""

  useEffect(() => {
    window.addEventListener('click', closeTime)
    return () => window.removeEventListener('click', closeTime)
  },[])
// END close time dropdown after click somewhere

   return (
      <>
        <div id="currentDateTime" className=" hidden font-lato lg:block ">
          <div className=" w-full  text-text_Quaternary1 text-[10px] lg:text-[12px] flex flex-col px-2">
            <div className="flex gap-1 text-text_color_primary4 items-center text-nowrap whitespace-nowrap pt-0.5">{getDate()} ( GMT +5.5:30 )</div>
            <span className="text-text_Quaternary text-xs lg:text-[14px] text-nowrap whitespace-nowrap font-semibold "> {getTime()} </span>
          </div>
        </div>
      </>
  )
}

export default connectTimeSettingsDesktop()(TimeSettingsDesktop)
